import { useState } from "react";
import { motion } from "framer-motion";

export default function ChatBooking() {

  const [messages, setMessages] = useState([
    { sender: "ai", text: "Hello 👋 I'm AutoHelper AI. How can I assist you today?" }
  ]);

  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = input;

    // Add user message
    setMessages((prev) => [
      ...prev,
      { sender: "user", text: userMessage }
    ]);

    setInput("");
    setTyping(true);

    try {

      // 🔥 FETCH ADDED HERE (Correct Place)
      const response = await fetch(
        "http://localhost/autohelper-api/chat.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ message: userMessage })
        }
      );

      if (!response.ok) {
        throw new Error("Server error");
      }

      const data = await response.json();

      setMessages((prev) => [
        ...prev,
        {
          sender: "ai",
          text: data.reply || "No response from server."
        }
      ]);

    } catch (error) {
      setMessages((prev) => [
        ...prev,
        {
          sender: "ai",
          text: "⚠ Server error. Please try again."
        }
      ]);
    }

    setTyping(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-200 via-indigo-100 to-purple-200 p-6">

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-3xl h-[600px] bg-white/60 backdrop-blur-xl rounded-3xl shadow-2xl flex flex-col overflow-hidden border border-white/30"
      >

        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white p-4 font-semibold text-lg">
          🤖 AutoHelper AI Chat
        </div>

        {/* Chat Area */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">

          {messages.map((msg, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: msg.sender === "user" ? 50 : -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
              className={`max-w-xs px-4 py-3 rounded-2xl text-sm shadow-md whitespace-pre-line
                ${
                  msg.sender === "user"
                    ? "bg-gradient-to-r from-blue-600 to-indigo-600 text-white ml-auto"
                    : "bg-white text-gray-800"
                }`}
            >
              {msg.text}
            </motion.div>
          ))}

          {typing && (
            <div className="bg-white px-4 py-2 rounded-2xl w-fit shadow-md text-gray-500 text-sm">
              AI is typing...
            </div>
          )}

        </div>

        {/* Input Area */}
        <div className="p-4 bg-white flex gap-3 border-t">

          <input
            type="text"
            placeholder="Type your service request..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
            className="flex-1 px-4 py-3 rounded-full border focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
          />

          <button
            onClick={sendMessage}
            className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-3 rounded-full hover:scale-105 transition duration-300 shadow-lg"
          >
            Send
          </button>

        </div>

      </motion.div>
    </div>
  );
}
